module.exports = __webpack_public_path__ + "static/media/47_tn.92e53dea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/47_tn.jpg
// module id = 260
// module chunks = 0